






































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { RiskMatrixItemRequest } from '../../models/jobServiceForm/riskMatrixItemRequest';
import OptionSelector from '@/components/common/OptionSelector.vue';
import { WorkActivity } from '../../models/jobServiceForm/workActivity';
import { RiskScore } from '../../models/jobServiceForm/riskScore';
import { ResidualRiskScore } from '../../models/jobServiceForm/residualRiskScore';
import { RiskOption } from '../../models/jobServiceForm/riskOption';
import { ControlMeasureOption } from '../../models/jobServiceForm/controlMeasureOption';
import { RiskMatrixOptions } from '../../models/jobServiceForm/riskMatrixOptions';

@Component({
  components: {
    OptionSelector
  }
})
export default class RiskMatrixItemForm extends Vue {
  @Prop({ type: Number, default: 1 }) public itemNumber!: number;
  @Prop({ type: Object, default: null }) public item!: RiskMatrixItemRequest;
  @Prop({ type: Object, default: null }) public options!: RiskMatrixOptions;

  private editMode: boolean = false;
  private editedItem: RiskMatrixItemRequest = this.getClearEditedItem();
  private workActivityOtherID: number = 8;
  edit(){
    this.editMode = true;

    this.clearEditedItem();
    this.editedItem.workActivity = parseInt(`${this.item.workActivity}`);
    this.editedItem.risks = `${this.item.risks}`;
    this.editedItem.riskScore = parseInt(`${this.item.riskScore}`);
    this.editedItem.controlMeasures = `${this.item.controlMeasures}`;
    this.editedItem.residualRiskScore = parseInt(`${this.item.residualRiskScore}`);
    this.editedItem.riskRisks = this.item.riskRisks;
    this.editedItem.riskControlMeasures = this.item.riskControlMeasures;
    this.editedItem.workActivityFreeText = this.item.workActivityFreeText;
  }

  clearEditedItem(){
    this.editedItem = this.getClearEditedItem();
  }

  getClearEditedItem(): RiskMatrixItemRequest{
    return {
      workActivity: 0,
      risks: null,
      riskScore: 0,
      controlMeasures: null,
      residualRiskScore: 0,
      riskRisks: [],
      riskControlMeasures: [],
      workActivityFreeText: null,
      jobDefault: null
    };
  }

  cancelEdit(){
    if(this.item.workActivity == 0){
      this.$emit('onDelete');
    }

    this.clearEditedItem();

    this.editMode = false;
  }

  closeEdit(){
    let form: any = this.$refs.riskMatrixItemForm;
    if(!form.validate()){
      return;
    }

    this.item.workActivity = this.editedItem.workActivity;
    this.item.risks = this.editedItem.risks;
    this.item.riskScore = this.editedItem.riskScore;
    this.item.controlMeasures = this.editedItem.controlMeasures;
    this.item.residualRiskScore = this.editedItem.residualRiskScore;
    this.item.workActivityFreeText = this.editedItem.workActivityFreeText;
    this.item.riskRisks = this.editedItem.riskRisks;
    this.item.riskControlMeasures = this.editedItem.riskControlMeasures;
    this.clearEditedItem();

    this.editMode = false;
  }

  remove(){
    this.$emit('onDelete');
    this.cancelEdit();
  }

  selectRequired(v: number) {
    if(v == null || v == 0){
      return "Must select an option";
    }

    return true;
  }

  textRequired(v: string) {
    if(v == null || v.length == 0){
      return "Cannot be left blank";
    }

    return true;
  }

  get riskItemTitle(){
    return `Risk Item #${this.itemNumber}`;
  }

  get workActivityOptions(): WorkActivity[] {
    return this.options.workActivityOptions
      .filter((x): boolean => this.item.workActivity > 0 || (this.item.workActivity == 0 && !x.jobDefault))
      .sort((a, b) => {
        if(a.name > b.name){
          return 1;      
        }

        if(a.name < b.name){
          return -1;      
        }

        return 0;
      });
  }

  get riskScoreOptions(): RiskScore[] {
    return this.options.riskScoreOptions;
  }

  get residualRiskScoreOptions(): ResidualRiskScore[] {
    return this.options.residualRiskScoreOptions;
  }

  get riskOptions(): RiskOption[] {
    if(this.editedItem.workActivity > 0) {
      return this.options.riskOptions.filter(r=> r.workActivityId == this.editedItem.workActivity);
    } else {
      return [];
    }
  }

  get controlMeasureOptions(): ControlMeasureOption[] {
    if(this.editedItem.workActivity > 0) {
      return this.options.controlMeasureOptions.filter(r=> r.workActivityId == this.editedItem.workActivity);
    } else {
      return [];
    }
  }

  get workActivity(){
    if(this.item.workActivity == this.workActivityOtherID) {
      return this.item.workActivityFreeText;
    } else {
      let option = this.workActivityOptions.find(x => x.id === this.item.workActivity);
      if(option){
        return option.name;
      }
    }
    return null;
  }

  get controlMeasures() {
    if(this.item.workActivity == this.workActivityOtherID) {
      return this.item.controlMeasures;
    } else if(this.item.riskControlMeasures) {
      var controlMeasuresTexts = [];
      for(var i = 0; i < this.item.riskControlMeasures.length; i ++) {
        let option = this.options.controlMeasureOptions.find(x => x.id == this.item.riskControlMeasures[i].id);
        controlMeasuresTexts.push(option.name);
      }
      return controlMeasuresTexts.join("<br />");
    }
    return null;
  }

  get risks() {
    if(this.item.workActivity == this.workActivityOtherID) {
      return this.item.risks;
    } else if(this.item.riskRisks) {
      var risksTexts = [];
      for(var i = 0; i < this.item.riskRisks.length; i ++) {
        let option = this.options.riskOptions.find(x => x.id == this.item.riskRisks[i].id);
        risksTexts.push(option.name);
      }
      return risksTexts.join("<br />");
    }
    return null;
  }

  get riskScore(){
    let option = this.riskScoreOptions.find(x => x.id === this.item.riskScore);
    if(option){
      return option.name;
    }

    return null;
  }

  get residualRiskScore(){
    let option = this.residualRiskScoreOptions.find(x => x.id === this.item.residualRiskScore);
    if(option){
      return option.name;
    }

    return null;
  }

  onWorkActivityChanged() {
    if(this.editedItem.workActivity > 0) {
      let selectedWorkActivity: WorkActivity = this.workActivityOptions.find(w=> w.id == this.editedItem.workActivity);
      this.editedItem.riskScore = selectedWorkActivity.riskScoreId;
      this.editedItem.residualRiskScore = selectedWorkActivity.residualRiskScoreId;
      this.editedItem.riskRisks = [];
      this.editedItem.riskControlMeasures = [];
      if(this.editedItem.workActivity != 8) {
        this.editedItem.risks = "";
        this.editedItem.controlMeasures = "";
        this.editedItem.workActivityFreeText = "";
      }
    }
  }
}

